import styled from "styled-components";

const StyledHeader = styled.h1`
    color: #232323;
    font-family: "Roboto","serif";
    font-size: 45px;
    font-weight: bold;
    margin: 50px;
    text-align: center;
    @media (max-width: 800px) {
        font-size: 24px;
    }
`;


function Header1({title}) {
  return (
          <StyledHeader>
              {title}
          </StyledHeader>
  );
}

export default Header1;
